import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 41,
	height: 41,
	fill: "none",
	viewBox: "0 0 41 41",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M20.5 41a20.5 20.5 0 1 0 0-41 20.5 20.5 0 0 0 0 41z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			fillRule: "evenodd",
			d: "M10.3 18.4a4 4 0 0 0-4.1 4.1h-2a6.1 6.1 0 0 1 6-6.1h2.1a6.1 6.1 0 0 1 6.2 6.1h-2a4 4 0 0 0-4.2-4h-2zm1-5a3 3 0 1 0 0-6.2 3 3 0 0 0 0 6.1zm0 2a5.1 5.1 0 1 0 0-10.3 5.1 5.1 0 0 0 0 10.3z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M18 15.4a5.1 5.1 0 0 1 5 5h-2c0-1.6-1.5-3-3.6-3-.5-.5-1-1-2.5-1.5 0 0 1.4-.5 2-.5h1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			fillRule: "evenodd",
			d: "M17 12.3a5.1 5.1 0 0 1-1.2 1.7 4 4 0 1 0 0-7.5A5.1 5.1 0 0 1 17 8.2a2 2 0 1 1 0 4zm-7.7 5.1a4 4 0 0 0-4.1 4h-2a6.1 6.1 0 0 1 6-6h2.1a6.1 6.1 0 0 1 6.1 6.1h-2a4 4 0 0 0-4.1-4.1h-2zm1-5.1a3 3 0 1 0 0-6.2 3 3 0 0 0 0 6.2zm0 2a5.1 5.1 0 1 0 0-10.2 5.1 5.1 0 0 0 0 10.2z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#111",
			d: "M17 14.3a5.1 5.1 0 0 1 5 5.2h-2c0-1.7-1.5-3.1-3.6-3.1-.5-.5-1-1-2.5-1.6 0 0 1.4-.5 2-.5h1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			fillRule: "evenodd",
			d: "M16 11.2a5.1 5.1 0 0 1-1.2 1.8 4 4 0 1 0 0-7.5A5.1 5.1 0 0 1 16 7.2a2 2 0 1 1 0 4z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			d: "M17.4 25.6a4 4 0 0 0-4 4h-2.1a6.1 6.1 0 0 1 6.1-6h2a6.1 6.1 0 0 1 6.2 6.1h-2a4 4 0 0 0-4.1-4h-2zm1-5.1a3 3 0 1 0 0-6.1 3 3 0 0 0 0 6zm0 2a5.1 5.1 0 1 0 0-10.2 5.1 5.1 0 0 0 0 10.2z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M25.1 22.5a5.1 5.1 0 0 1 5.1 5.2h-2c0-1.7-1.6-3.1-3.6-3.1-.5-.5-1-1-2.6-1.5 0 0 1.5-.6 2-.6h1.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			d: "M24.2 19.4a5.1 5.1 0 0 1-1.2 1.8 4 4 0 1 0 0-7.5c.5.5 1 1 1.2 1.7a2 2 0 1 1 0 4z",
			clipRule: "evenodd"
		})
	]
});
export default SvgProfileGroup;
